export default {
  objTypeFromId(id) {
    return id.split('::')[0];
  },
};
